import React, { Component, useState, useEffect } from 'react';
import { connect, } from 'react-redux';
import { Container, Spinner, Row, Col } from 'react-bootstrap';
import Lottie from "react-lottie";
import { withRouter } from '../withRouter';
import { getStateCallbacks } from "colyseus.js";
import { joinRoom, reconnectToRoom } from 'actions/room';
import * as Sentry from "@sentry/react";
import { APP_TYPES } from "constants/AppTypes"
import Game from "components/Games/Game"

import styles from "components/Room/Play.module.scss";
import DotLoader from 'components/Utlility/DotLoader';

import { getGameList, getPlayableGames, findPlayableGameById, initializeGames, isGamesLoading } from "constants/GameListAdapter";
import GameMenu from "./GameMenu";
import GameVote from "../Games/GameVote"

import BuyForLobbyModal from 'components/BuyForLobbyModal/BuyForLobbyModal';
import AvatarCreator from 'components/AvatarCreator/AvatarCreator';
import { getMyCustomAvatars, createCustomAvatar, updateCustomAvatar, deleteCustomAvatar } from 'services/customAvatar';
import UpsellModal from 'components/Modals/UpsellModal/UpsellModal';
import RatingModal from 'components/Modals/RatingModal/RatingModal';
import { getCookie } from 'helpers/cookies';

import {iosTransaction, androidTransaction} from 'services/AppTransactions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import placeHolderDesktop from 'images/gameStorePreviews/placeholder-desktop.svg';
import placeHolderLogo from 'images/gameLogos/placeholder-logo.svg';
import placeHolderBackground from 'images/storeBackgrounds/placeholder-background.svg';

const upsellBrackets = [1, 5, 10, 20];

class Play extends Component {
    static displayName = Play.name;

    constructor(props) {
        super(props);

        this.state = {
            roomId: "",
            sessionId: "",
            nickname: "",
            showAvatars: false,
            avatarTab: "pick",
            chosenAvatar: null,
            player: null,
            selectedGame: null,
            hostUser: null,
            userCalledPurchase: false,
            gotLocationPing: true,
            connectionIssue: false,
            isInApp: false,
            showPurchasedModal: false,
            newGamePurchased: null,
            showRatingModal: false,
            savedAvatars: [],
            savingAvatar: false,
            editAvatarId: null,
            editAvatarConfig: null,
            nicknameInitialised: false,
            gamesLoaded: getPlayableGames().length > 0,
        };
        this.buyForLobbyModal = React.createRef();
    }

    componentDidMount() {
        if (this.props.room.roomOpen) {
            if (this.props.room.isHost) {
                return setTimeout(() => this.props.navigate("/lobby"));
            } else {
                this.setRoomVars();
            }
        } else {
            const queryParams = new URLSearchParams(window.location.search);
            const isRoku = queryParams.has("roku")
            if (queryParams.has("qrCode")) {
                return setTimeout(() => this.props.navigate(`/join?qrCode=${queryParams.get("qrCode")}${isRoku ? "&roku=true" : ""}`));
            } else if (queryParams.has("token")) {
                this.props.reconnectToRoom(queryParams.get("token")).then((res) => {
                    if (res.Status === "Error") {
                        return setTimeout(() => this.props.navigate(`/join${isRoku ? "roku=true" : ""}`));
                    } else {
                        this.doRatingModal();
                    }

                })
            } else if (queryParams.has("deviceType")) {
                const deviceType = queryParams.get("deviceType");
                if (deviceType === 'ios') this.setState({ deviceType: 'ios' });
            } else {
                return setTimeout(() => this.props.navigate(`/join${isRoku ? "roku=true" : ""}`));
            }
        }
        //console.log("avaiable games:", this.props.room.roomState.availableGames, "from room state: ", this.props.room.roomState, "and room: ", this.props.room.room)
        this.ensureGamesLoaded();
        this.checkForMobileDevice();

        if (typeof window !== "undefined") {
            this.setupIOSBridge();
            this.setupAndroidBridge();
        }
    }

    setupIOSBridge() {
        window.onPurchaseComplete = (status, jws) => {
            if (status === "success" && jws) {
                alert('Purchase Successful! You can now play the game.');
                const hostUserEmail = this.state.hostUser || "";
                const payload = {
                    SignedTransactionJws: jws,
                    AutoRedeemUsername: hostUserEmail
                };

                iosTransaction(payload, this.onPurchased);
            } else if (status === "success") {
                alert('Purchase Successful! You can now play the game.');
                this.onPurchased();
            } else {
                alert('Purchase Failed or Cancelled. Please try again later.');
            }
        };
    }

    setupAndroidBridge() {
        window.onAndroidPurchaseVerified = (productId, purchaseToken, email) => {
            //console.log("✅ Purchase received from Android:");
            //console.log("   Product ID:", productId);
            //console.log("   Token:", purchaseToken);

            this.sendTestLogToAndroid(`Purchase received from Android: Product ID: ${productId}, Token: ${purchaseToken}, Email: ${email}`)

            const payload = {
                SKU: productId,
                purchaseToken: purchaseToken,
                AutoRedeemUsername: email
            };

            androidTransaction(payload, this.onPurchased)
        };
    }

    sendTestLogToAndroid(log) {
        if (window.AndroidBridge?.androidAppReady) {
            window.AndroidBridge.androidAppReady(log);
        }
    }

    checkForMobileDevice() {
        if (window.webkit?.messageHandlers?.appReady) {
            window.webkit.messageHandlers.appReady.postMessage("ready")
            this.registerIosCallbacks();
        }
        if (window.AndroidBridge?.androidAppReady) {
            window.AndroidBridge.androidAppReady("ready");
            this.registerAndroidCallbacks();
            this.setState({ isInApp: true })
        }
    }

    registerAndroidCallbacks = () => {
        window.onAndroidReady = () => {
            this.setState({ isInApp: true })
        }
    }

    registerIosCallbacks = () => {
        window.onNativeReady = () => {
            if (window.webkit?.messageHandlers?.logHandler) {
                window.webkit.messageHandlers.logHandler.postMessage(`SENT BACK TO CLIENT`)
                this.setState({ isInApp: true })
            }
        }
    }



    setHostUserFromState() {
        const email = this.props.room.roomState.hostUserEmail || "";
        this.setState({ hostUser: { email, sub: email } });
    }

    setRoomVars() {
        const player = this.getActivePlayer();
        this.setState({
            roomId: this.props.room.roomId,
            sessionId: this.props.room.sessionId,
            nickname: player?.name || "",
        });
        this.updateToken(this.props.room.room.reconnectionToken);
        this.setTags();
        this.startLocationChecks();
        this.setHostUserFromState();
        this.setUpsellItem();
    }

    ensureGamesLoaded() {
        if (getPlayableGames().length > 0) {
            if (!this.state.gamesLoaded) this.setState({ gamesLoaded: true });
            return;
        }
        // Game catalog not loaded yet - wait for initializeGames to complete then re-render
        initializeGames().then(() => {
            if (getPlayableGames().length > 0) {
                this.setState({ gamesLoaded: true });
            }
        });
    }

    setUpsellItem() {
        const lastGameId = this.props.room.roomState.lastGameId;
        console.log("Last Game Id : ", lastGameId);
        if (!lastGameId || lastGameId.length === 0) {
            this.setState({ upsellItem: null });
            return;
        }

        // Find the product that contains this game (products have gameIds array linking to games they grant)
        const product = getGameList().find((g) => g.gameIds?.includes(lastGameId));
        console.log("Found product for game: ", product);

        if (!product || !product.gameUpsellIds) {
            this.setState({ upsellItem: null });
            return;
        }

        // Collect upsell IDs from the product
        let possibleIds = product.gameUpsellIds;
        console.log("Possible Ids : ", possibleIds);

        // Filter out ones already in available games
        possibleIds = possibleIds.filter(id => !this.props.room.roomState.availableGames.includes(id));
        console.log("Possible Ids 2: ", possibleIds);

        if (possibleIds.length === 0) {
            this.setState({ upsellItem: null });
            return;
        }

        // Convert to actual product objects (match by gameId or by gameIds containing the upsell ID)
        let possibleGames = getGameList().filter(game =>
            game.status !== 'disabled' &&
            (possibleIds.includes(game.gameId) || game.gameIds?.some(gid => possibleIds.includes(gid)))
        );
        console.log("Possible games: ", possibleGames);

        if (possibleGames.length === 0) {
            this.setState({ upsellItem: null });
            return;
        }

        // Pick a random game
        const randomGame = possibleGames[Math.floor(Math.random() * possibleGames.length)];
        this.setState({ upsellItem: randomGame });
        return;
    }

    upsellModalCallback = () => {
        this.setState({ upsellItem: null });
        localStorage.setItem(`${this.props.room.roomId}-${this.props.room.roomState.gamesPlayed}-upsell`, true);
    }

    upsellOverrideCallback = () => {
        this.onBuyGameForLobby(this.state.upsellItem);
        this.upsellModalCallback()
    }

    updateToken(token) {
        var url = new URL(window.location.href);

        try {
            window.history.replaceState(null, null, (url.pathname) + (`?token=${token}`));
        } catch (e) {
            console.warn(e)
        }
    }


    setTags() {
        const queryParams = new URLSearchParams(window.location.search);

        const token = queryParams.get("token");
        Sentry.setTag('isPlayer', true);

        if (token) {
            const [roomId, reconnectToken] = token.split(':');
            Sentry.setTag('roomId', roomId);
            Sentry.setTag('reconnectToken', reconnectToken);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.room.roomOpen === false && prevProps.room.roomOpen === true) {
            const queryParams = new URLSearchParams(window.location.search);
            const isRoku = queryParams.has("roku")
            this.props.navigate(`/join${isRoku ? "roku=true" : ""}`);
        } else if (this.props.room.roomOpen === true && prevProps.room.roomOpen === false) {
            this.setRoomVars();
        } else if (this.state.isInApp && this.state.BuyForLobbyGame && this.state.userCalledPurchase === true) {
            if (window.webkit?.messageHandlers) {
                this.triggerIOSPurchase(this.state.BuyForLobbyGame);
            } else if (window.AndroidBridge?.purchaseGame) {
                this.triggerAndroidPurchase(this.state.BuyForLobbyGame);
            }
            this.setState({ userCalledPurchase: false })
        } else if (this.state.roomId !== "" && this.state.userCalledPurchase && this.state.isInApp) {
            this.enableIOSPurchases();
        } else if (this.props.room.roomState.availableGames !== prevProps.room.roomState.availableGames) {
            this.getNewestGame(this.props, prevProps)
        }

        // Sync nickname from Colyseus state on initial load only
        // (race condition: first state snapshot may arrive before server sets player.name)
        if (this.props.room.roomOpen && !this.state.nicknameInitialised) {
            const player = this.getActivePlayer();
            if (player?.name) {
                this.setState({ nickname: player.name, nicknameInitialised: true });
            }
        }

        this.doRatingModal();
    }

    doRatingModal = () => {
        // Check for rating modal trigger when games played crosses 3
        const currentGamesPlayed = this.props.room.roomState?.gamesPlayed || 0;
        if (currentGamesPlayed >= 3 && !this.state.showRatingModal) {
            const hasSeenRating = getCookie('game-rating-shown');
            if (!hasSeenRating) {
                // Delay slightly to not conflict with other modals
                setTimeout(() => {
                    this.setState({ showRatingModal: true });
                }, 1000);
            }
        }
    }

    getNewestGame = (props, prevProps) => {
        const newGame = props.room.roomState.availableGames.find(gameId =>
            !prevProps.room.roomState.availableGames.includes(gameId)
        );

        if (newGame) {
            const game = findPlayableGameById(newGame);
            if (game) {
                this.setState({ newGamePurchased: game, showPurchasedModal: true });
            }
        }
    }

    componentWillUnmount() {

        if (window.onPurchaseComplete) {
            window.onPurchaseComplete = null;
        }

        if (window.onAndroidPurchaseVerified) {
            window.onAndroidPurchaseVerified = null;
        }

    }


    enableIOSPurchases() {
        if (window.webkit?.messageHandlers?.enablePurchases) {
            window.webkit.messageHandlers.enablePurchases.postMessage();
        }
    }


    triggerIOSPurchase(game) {
        let gameID = game.iosGameID || game.gameId;
        if (window.webkit?.messageHandlers.logHandler) {
            window.webkit.messageHandlers.logHandler.postMessage(`HOST: ${JSON.stringify(this.state.hostUser)}`);
        }

        if (window.webkit?.messageHandlers.purchaseHandler) {
            window.webkit.messageHandlers.purchaseHandler.postMessage({
                productID: gameID,
                hostUser: JSON.stringify(this.state.hostUser)
            });
        } else {
            alert('In-app purchases are not available')
            this.setState({ BuyForLobbyGame: null })
        }
    }

    triggerAndroidPurchase(game) {
        let gameID = game.androidGameID || null;
        if (window.AndroidBridge?.purchaseGame) {
            const payload = JSON.stringify({ productID: gameID, hostUser: JSON.stringify(this.state.hostUser) })
            window.AndroidBridge.purchaseGame(payload);
        } else {
            alert('In-app purchases are not available')
            this.setState({ BuyForLobbyGame: null })
        }
    }

    onChangeNickname = (e) => {
        const re = /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/;
        const nickname = e.target.value.toUpperCase();
        if (nickname === '' || re.test(nickname)) {
            this.setState({ nickname });
        }
    };

    submitNickname = () => {
        const player = this.getActivePlayer();
        if (this.state.nickname && this.state.nickname !== player.name) {
            localStorage.setItem("nickname", this.state.nickname);
            this.props.room.room.send("update_custom_avatar", { avatarDataUrl: player.avatar, nickName: this.state.nickname });
        }
    };

    startLocationChecks() {
        if (this.props.room.roomOpen) {
            this.props.room.room.send("location_check", { gameId: "lobby", });

            this.props.room.room.onMessage("location_confirmed", (message) => {
                console.log("location_confirmed", "received on", this.props.room.room.name, message);
                this.setState({ gotLocationPing: true, });
            });
        }
        this.locationCheckInterval = setInterval(() => {
            if (this.props.room.roomOpen) {
                if (this.state.gotLocationPing) {
                    this.setState({ gotLocationPing: false, connectionIssue: false, });
                } else {
                    this.setState({ connectionIssue: true, });
                }
                this.props.room.room.send("location_check", { gameId: "lobby", });
            }
        }, 10000);
    }

    getActivePlayer() {
        return this.props.room.players.find(x => x.id === this.props.room.sessionId);
    }

    getAvatars() {
        const player = this.getActivePlayer();
        const currentAvatar = player.avatar;

        const activeAvatars = this.props.room.avatarList.filter(value => value.isActive);

        return (
            <div className={styles.avatarGrid}>
                {activeAvatars.map((value) => (
                    <div
                        key={value.id}
                        className={`${styles.avatar} ${this.state.chosenAvatar === value.id && !value.inUse && styles.selected} ${currentAvatar === value.src && styles.applied}`}
                        onClick={() => this.chooseAvatar(value.id)}
                    >
                        {value.inUse && currentAvatar !== value.src ? (
                            <img className={`${styles.potato} ${styles.fade}`} src={value.src} alt={value.name || 'avatar'} />
                        ) : (
                            <img className={styles.potato} src={value.src} alt={value.name || 'avatar'} />
                        )}
                    </div>
                ))}
            </div>
        );
    }

    /* getAvatarsByCategory - commented out for now
    getAvatarsByCategory() {
        const player = this.getActivePlayer();
        const currentAvatar = player.avatar;

        // Group avatars by category
        const grouped = {};
        const uncategorized = [];

        this.props.room.avatarList.forEach((value) => {
            if (value.isActive) {
                const category = value.category || '';
                if (category) {
                    if (!grouped[category]) {
                        grouped[category] = [];
                    }
                    grouped[category].push(value);
                } else {
                    uncategorized.push(value);
                }
            }
        });

        // Sort categories alphabetically (later can be ordered from admin)
        const sortedCategories = Object.keys(grouped).sort();

        // Build the JSX with category sections
        const sections = [];

        sortedCategories.forEach((category) => {
            sections.push(
                <div key={category} className={styles.categorySection}>
                    <div className={styles.categoryAvatars}>
                        {grouped[category].map((value) => (
                            <div
                                key={value.id}
                                className={`${styles.avatar} ${this.state.chosenAvatar === value.id && !value.inUse && styles.selected} ${currentAvatar === value.src && styles.applied}`}
                                onClick={() => this.chooseAvatar(value.id)}
                            >
                                {value.inUse && currentAvatar !== value.src ? (
                                    <img className={`${styles.potato} ${styles.fade}`} src={value.src} alt={value.name || 'avatar'} />
                                ) : (
                                    <img className={styles.potato} src={value.src} alt={value.name || 'avatar'} />
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            );
        });

        // Add uncategorized avatars at the end if any
        if (uncategorized.length > 0) {
            sections.push(
                <div key="uncategorized" className={styles.categorySection}>
                    <div className={styles.categoryAvatars}>
                        {uncategorized.map((value) => (
                            <div
                                key={value.id}
                                className={`${styles.avatar} ${this.state.chosenAvatar === value.id && !value.inUse && styles.selected} ${currentAvatar === value.src && styles.applied}`}
                                onClick={() => this.chooseAvatar(value.id)}
                            >
                                {value.inUse && currentAvatar !== value.src ? (
                                    <img className={`${styles.potato} ${styles.fade}`} src={value.src} alt={value.name || 'avatar'} />
                                ) : (
                                    <img className={styles.potato} src={value.src} alt={value.name || 'avatar'} />
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            );
        }

        return sections;
    }
    */

    chooseAvatar(id) {
        this.setState({ chosenAvatar: id });
        this.props.room.room.send("update_avatar", { avatarId: id, });
    }

    applyNameAndAvatar = (e) => {
        e.preventDefault();

        window.scrollTo(0, 0);
        this.setState({ showAvatars: false });
        localStorage.setItem("nickname", this.state.nickname);

        const player = this.getActivePlayer();
        if (this.state.chosenAvatar != null) {
            // User selected a predefined avatar
            this.props.room.room.send("update_avatar", { avatarId: this.state.chosenAvatar, nickName: this.state.nickname });
        } else if (this.state.nickname && this.state.nickname !== player.name) {
            // Only nickname changed, update via custom avatar message to preserve current avatar
            this.props.room.room.send("update_custom_avatar", { avatarDataUrl: player.avatar, nickName: this.state.nickname });
        }
    }


    voteForGame = (game) => {
        this.props.room.room.send("game_vote", { gameId: game.gameId });
    }

    loadGameMenu = (game) => {
        this.setState({ selectedGame: game });
    }

    closeGameMenu = () => {
        this.setState({ selectedGame: null });
    }

    leaveRoom = (id) => {
        this.props.room.room.leave(true);
    }

    showAvatars = () => {
        window.scrollTo(0, 0);
        let player = this.getActivePlayer();
        this.setState({ showAvatars: true, avatarTab: "pick", chosenAvatar: null, nickname: player.name, editAvatarId: null, editAvatarConfig: null });
        this.fetchSavedAvatars();
    }

    fetchSavedAvatars = async () => {
        try {
            const user = JSON.parse(localStorage.getItem("user"));
            if (user && user.token) {
                const avatars = await getMyCustomAvatars();
                this.setState({ savedAvatars: avatars || [] });
            }
        } catch (e) {
            console.log("Failed to fetch saved avatars:", e);
        }
    }

    onAvatarSave = async (dataUrl, config, editId) => {
        this.setState({ savingAvatar: true });
        try {
            if (editId) {
                await updateCustomAvatar(editId, dataUrl, config);
            } else {
                await createCustomAvatar(dataUrl, config);
            }
            // Select this avatar and go back to pick screen
            this.props.room.room.send("update_custom_avatar", { avatarDataUrl: dataUrl, nickName: this.state.nickname });
            await this.fetchSavedAvatars();
            this.setState({ avatarTab: "pick", editAvatarId: null, editAvatarConfig: null });
        } catch (e) {
            console.error("Failed to save avatar:", e);
        }
        this.setState({ savingAvatar: false });
    }

    onEditSavedAvatar = (avatar) => {
        const config = JSON.parse(avatar.configJson);
        this.setState({ avatarTab: "create", editAvatarId: avatar.id, editAvatarConfig: config });
    }

    onDeleteSavedAvatar = async (avatarId) => {
        try {
            await deleteCustomAvatar(avatarId);
            await this.fetchSavedAvatars();
        } catch (e) {
            console.error("Failed to delete avatar:", e);
        }
    }

    onSelectSavedAvatar = (avatar) => {
        this.setState({ showAvatars: false });
        this.props.room.room.send("update_custom_avatar", { avatarDataUrl: avatar.imageUrl, nickName: this.state.nickname });
    }

    openAvatarCreator = () => {
        this.setState({ avatarTab: "create", editAvatarId: null, editAvatarConfig: null });
    }

    refreshGames = () => {
        this.setState({ refreshingGames: true, refreshCooldown: 10 });
        this.props.room.room.send("refresh_lobby_games", {});

        const cooldown = setInterval(() => {
            const cooldownTime = this.state.refreshCooldown - 1;
            this.setState({ refreshCooldown: cooldownTime });
            if (cooldownTime === 0) {
                this.setState({ refreshingGames: false });
                clearInterval(cooldown);
            }
        }, 1000);
    }

    onBuyGameForLobby = (game) => {
        this.setState({ BuyForLobbyGame: game, userCalledPurchase: true });
    }

    onPurchased = () => {
        //console.log("on purchased hit ")
        this.sendTestLogToAndroid("onPurchased called from Play.js")
        window.scrollTo(0, 0);
        this.setState({ BuyForLobbyGame: null, purchaseTestDebug: true });
        this.refreshGames();
    }

    isDev() { return !process.env.REACT_APP_ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT === 'development' }

    doesntOwnSubGames(g) {
        if (g.isPack) {
            let subOwnedCount = 0;
            g.subGames.forEach(z => {
                if (this.props.room.roomState.availableGames?.findIndex((y) => y.code === z)) {
                    subOwnedCount++;
                }
            });
            if (subOwnedCount < g.subGames.length) return true;
            else return false;
        } else {
            return true;
        }
    }

    renderBuyMoreGames() {
        const missingGames = getGameList().filter(g => (g.status !== 'disabled' || this.isDev()) && !this.props.room.roomState.availableGames?.find((y) => g.gameId === y) && g.supportedPlatforms.includes(this.props.room.roomState.platform) && this.doesntOwnSubGames(g));

        if (missingGames.length <= 0) return;

        if (this.props.room.roomState.platform === APP_TYPES.FIRE_TV) return;
        
        return <React.Fragment>
            <h2>Add Games</h2>
            <Row className={`${styles.buyMoreList}`}>
                {
                    missingGames.map((g, i) => {
                        if (!g) return null;
                        return <Col key={g.gameId} md={12} sm={12} xs={12} style={{ padding: "1vh" }}>
                            <Game game={g} key={g.gameId}
                                buyNowText="Buy Now and Play"
                                onClickOverride={this.onBuyGameForLobby}
                                onBuyNow={this.onBuyGameForLobby}
                                showBuyNow={true}
                                isInApp={this.state.isInApp}
                                hostUser={this.state.hostUser} />
                        </Col>
                    })
                }
            </Row>
        </React.Fragment>
    }

    render() {
        const primaryPlayer = this.props.room.players?.find(p => p.primaryPlayer)
        const availableGamesData = getPlayableGames().filter(g => this.props.room.roomState.availableGames?.find((y) => g.gameId === y) && !g.tags?.includes('is-pack') /*&& g.supportedPlatforms.includes(this.props.room.roomState.platform)*/);
        const player = this.getActivePlayer();
        const gamesStillLoading = !this.state.gamesLoaded || this.props.room.roomState.availableGames?.length === 0;

        const gamesPlayed = this.props.room.roomState.gamesPlayed;
        const matchedUpsellBracket = upsellBrackets.find(x => x === gamesPlayed);
        const showUpsell = matchedUpsellBracket && !localStorage.getItem(`${this.props.room.roomId}-${gamesPlayed}-upsell`) && this.state.upsellItem && player.primaryPlayer;

        const limitAccessFireTv = this.props.room?.roomState?.platform === APP_TYPES.FIRE_TV || this.props.devices.limitAccessFireTv;

        return (
            <div className={styles.pageWrap}>
                <Container>
                    {showUpsell && !limitAccessFireTv && <UpsellModal upsellItem={this.state.upsellItem} callback={this.upsellModalCallback} purchaseCallback={this.upsellOverrideCallback} overrideText={"BUY NOW"}></UpsellModal>}
                    {
                        player != null && this.props.room.roomOpen ?
                            <Container className="text-center position-relative" style={{ maxWidth: "600px" }}>
                                {
                                    this.state.connectionIssue &&
                                    <div className={styles.connectionIssueContainer}>
                                        <div className={styles.connectionText}>There might be an issue with your connection...<br />Click below to refresh!</div>
                                        <div className={styles.refreshButton} onClick={() => window.location.reload()}>&#x21bb;</div>
                                    </div>
                                }
                                {
                                    this.state.showAvatars ?
                                        <React.Fragment>
                                            {/* Avatar Creator - commented out for now
                                            {this.state.avatarTab === "create" ? (
                                                <AvatarCreator
                                                    onSave={this.onAvatarSave}
                                                    onCancel={() => this.setState({ avatarTab: "pick", editAvatarId: null, editAvatarConfig: null })}
                                                    editConfig={this.state.editAvatarConfig}
                                                    editId={this.state.editAvatarId}
                                                    saving={this.state.savingAvatar}
                                                />
                                            ) : (
                                                <React.Fragment>
                                                    {this.state.savedAvatars.length === 0 ? (
                                                        <button
                                                            className={`${styles.button} ${styles.createAvatarButton}`}
                                                            onClick={this.openAvatarCreator}
                                                        >
                                                            Create Custom Avatar
                                                        </button>
                                                    ) : (
                                                        <div className={styles.savedAvatarsSection}>
                                                            <h4 className={styles.savedAvatarsTitle}>MY AVATARS</h4>
                                                            <div className={styles.savedAvatarsGrid}>
                                                                {this.state.savedAvatars.map(avatar => (
                                                                    <div key={avatar.id} className={styles.savedAvatarItem} onClick={() => this.onSelectSavedAvatar(avatar)}>
                                                                        <div className={styles.savedAvatarImage}>
                                                                            <img src={avatar.imageUrl} alt="Saved avatar" />
                                                                        </div>
                                                                        <button className={styles.savedAvatarEditBtn} onClick={(e) => { e.stopPropagation(); this.onEditSavedAvatar(avatar); }} title="Edit">&#9998;</button>
                                                                    </div>
                                                                ))}
                                                                {this.state.savedAvatars.length < 8 && (
                                                                    <div className={styles.savedAvatarItem}>
                                                                        <div className={styles.savedAvatarAdd} onClick={this.openAvatarCreator}>
                                                                            <span>+</span>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </React.Fragment>
                                            )}
                                            End Avatar Creator */}

                                            <div className={styles.avatarList}>
                                                {this.getAvatars()}
                                            </div>

                                            <button className={`${styles.button} ${styles.small}`} onClick={this.applyNameAndAvatar}>Done</button>
                                        </React.Fragment>
                                        :
                                        <React.Fragment>
                                            {!limitAccessFireTv && (
                                                <button onClick={this.leaveRoom} className={styles.lobbyButton}>
                                                    <span className={styles.backIcon}><FontAwesomeIcon icon={faChevronLeft} /></span> leave room
                                                </button>
                                            )}

                                            <div className={styles.playerSection}>
                                                <div className={styles.avatarWrapper}>
                                                    <img className={styles.avatarImage} src={player.avatar} alt="avatar" />
                                                    <button className={styles.avatarEditIcon} onClick={() => this.showAvatars()}><FontAwesomeIcon icon={faPencil} /></button>
                                                </div>
                                                <div className={styles.nicknamePanel}>
                                                    <div className={styles.nicknameWrapper}>
                                                        <input
                                                            ref={(input) => { this.nicknameInput = input; }}
                                                            type="text"
                                                            className={styles.nicknameInput}
                                                            value={this.state.nickname}
                                                            placeholder="NICKNAME"
                                                            maxLength={10}
                                                            onChange={this.onChangeNickname}
                                                            onBlur={this.submitNickname}
                                                            onKeyDown={(e) => { if (e.key === 'Enter') e.target.blur(); }}
                                                        />
                                                        <button className={styles.nicknameEditIcon} onClick={() => this.nicknameInput?.focus()}><FontAwesomeIcon icon={faPencil} /></button>
                                                    </div>
                                                </div>
                                            </div>

                                            {
                                                player.primaryPlayer ?
                                                    <React.Fragment>
                                                        <Row>
                                                            <h2>You're the VIP!</h2>
                                                            <p>As you joined first you get to<br /> choose the game.</p>
                                                        </Row>
                                                        <Row className={styles.voteForGames}>
                                                            {
                                                                gamesStillLoading ?
                                                                    <h3 className={styles.noGamesText}><DotLoader text="Loading games" /></h3>
                                                                    : availableGamesData.length === 0 ?
                                                                        <h3 className={styles.noGamesText}>No games</h3>
                                                                        : availableGamesData.map((g, i) => {
                                                                            return <Col key={g.gameId} md={6} sm={6} xs={6} style={{ padding: "1vh" }}>
                                                                                <GameVote game={g} clickEvent={this.loadGameMenu} showVotes={true} supported={g.supportedPlatforms.includes(this.props.room.roomState.platform)} />
                                                                            </Col>
                                                                        })
                                                            }
                                                            <button className={`${styles.refreshLobbyGamesButton} ${styles.button} ${styles.small}`} onClick={this.refreshGames} disabled={this.state.refreshingGames}> Refresh Lobby {this.state.refreshCooldown > 0 && this.state.refreshCooldown + "s"}</button>
                                                        </Row>
                                                    </React.Fragment>
                                                    :
                                                    <React.Fragment>
                                                        <Row>
                                                            <h2>{primaryPlayer?.name} is the VIP!</h2>
                                                            <p>Vote for which game<br /> you want to play.</p>
                                                        </Row>
                                                        <Row className={styles.voteForGames}>
                                                            {
                                                                gamesStillLoading ?
                                                                    <h3 className={styles.noGamesText}><DotLoader text="Loading games" /></h3>
                                                                    : availableGamesData.length === 0 ?
                                                                        <h3 className={styles.noGamesText}>No games</h3>
                                                                        : availableGamesData.map((g, i) => {
                                                                            return <Col md={6} sm={6} xs={6} style={{ padding: "1vh" }}>
                                                                                <GameVote game={g} selected={player.gameVote === g.gameId} clickEvent={this.voteForGame} supported={g.supportedPlatforms.includes(this.props.room.roomState.platform)} />
                                                                            </Col>
                                                                        })
                                                            }
                                                        </Row>
                                                    </React.Fragment>
                                            }
                                            {this.props.room.roomState.availableGames.length < getPlayableGames().length && this.renderBuyMoreGames()

                                            }

                                        </React.Fragment>
                                }
                                {
                                    this.state.selectedGame &&
                                    <GameMenu game={this.state.selectedGame} closeGameMenu={this.closeGameMenu} isMobile={true} supported={this.state.selectedGame.supportedPlatforms.includes(this.props.room.roomState.platform)} />
                                }
                            </Container>
                            :
                            <Container style={{ justifyContent: "center", alignItems: "center", padding: "5vh", display: "flex", position: "absolute", top: 0, bottom: 0 }}>
                                <DotLoader size="medium" variant="light" />
                            </Container>
                    }
                </Container>

                {this.state.BuyForLobbyGame &&
                    <>
                        {
                            this.state.isInApp === true ?
                                <></>
                                :
                                <BuyForLobbyModal
                                    game={this.state.BuyForLobbyGame}
                                    hostUser={this.state.hostUser}
                                    onPurchased={this.onPurchased}
                                    onClose={() => { this.setState({ BuyForLobbyGame: null }); }}
                                />
                        }
                    </>
                }
                {
                    this.state.showPurchasedModal &&
                    <>
                        <PurchasedModal state={this.state} closeModal={() => this.setState({ showPurchasedModal: false })} />
                    </>
                }
                {
                    this.state.showRatingModal &&
                    <RatingModal
                        roomId={this.props.room.roomId}
                        gamesPlayed={this.props.room.roomState?.gamesPlayed || 0}
                        platform={this.props.room.roomState?.platform || 'web'}
                        onClose={() => this.setState({ showRatingModal: false })}
                    />
                }
            </div>
        );
    }
}


const PurchasedModal = ({ state, closeModal }) => {
    const [newGame, setNewGame] = useState(null)

    useEffect(() => {
        if (state.newGamePurchased && state.newGamePurchased !== null) {
            setNewGame(state.newGamePurchased)
        }
    }, [state.newGamePurchased])


    const customGameStyles = {
        backgroundColor: newGame.meta?.storeAccentColour || '#2a2a2a',
        backgroundImage: `url(${newGame.meta?.storeBackground || placeHolderBackground})`,
        gameLogoImage: `url(${newGame.logo || placeHolderLogo})`,
    }

    const returnDoubleText = (text) => {
        return (
            <div className={styles.doubleTextContainer}>
                <h1 className={styles.doubleTextTop}>{text}</h1>
                <h1 className={styles.doubleTextBottom}>{text}</h1>
            </div>
        )
    }

    return (
        newGame !== null &&
        <div className={styles.purchasedModalContainer} style={customGameStyles}>

            {returnDoubleText("THANK YOU FOR YOUR PURCHASE!")}
            <img src={newGame.logo || placeHolderLogo} className={styles.purchasedModalGameLogo} />
            <img src={newGame.meta?.previewImages?.desktop1 || placeHolderDesktop} className={styles.purchaseModalPreviewImage} style={{ border: `10px solid ${newGame.meta?.storeAccentColour}` }} />
            <button onClick={() => closeModal()} className={styles.purchasedModalPlayButton}>Let's Play!</button>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        room: state.room,
        devices: state.devices,
    };
}


const mapDispatchToProps = (dispatch) => {
    return {
        joinRoom: (roomId, options) => {
            return dispatch(joinRoom(roomId, options))
        },
        reconnectToRoom: (token) => {
            return dispatch(reconnectToRoom(token))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Play));
